<template>
    <form
        @submit.prevent="resetPassword"
        :action="url"
        method="post"
        class="card border-2 border-sky-500 space-y-4"
    >
        <div class="py-4 space-y-4">
            <h1 class="text-2xl text-center text-gray-800 uppercase font-semibold">Reset Password</h1>
            <div class="w-12 mx-auto border-b-2 border-gray-300"></div>
        </div>

        <div class="p-4 bg-blue-50 rounded text-sm text-gray-600">
            Forgot your password? No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.
        </div>

        <text-input
            label="Email"
            v-model="form.email"
            :error="form.errors.email"
            placeholder="kevin.flynn@encom.com"
        />

        <loading-button
            :loading="form.processing"
            class="btn btn-green w-full"
        >
            Email Password Reset Link
        </loading-button>
    </form>
</template>

<script setup>
import useForm from '@/functions/useForm'
import { useNotificationStore } from '@/stores/notification'

const props = defineProps({
    url: {
        type: String,
        required: true,
    },
})

const notification = useNotificationStore()

const form = useForm({
    email: ''
})

const resetPassword = () => {
    notification.clear()
    form.post(props.url, {
        onSuccess: newNotification => {
            form.reset()
            notification.set(newNotification)
        }
    })
}
</script>
